import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import HtmlToReact from 'html-to-react';
import objectAssign from 'object-assign';
import { Checkbox, Container, Loader, Icon } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import { forceValidation } from '../../../../businessLogic/validation.js';
import MobileAlerts from '../mobile-alerts/content';
import AdvancedSettings from '../advanced-settings/content';
import { CustomBrandingLogo } from '../../../shared/bottom-logo/content.js';
import { updateMicrophoneSettingsForProvider, updateVideoSettingsForProvider } from '../../../../actions/waitingArea';
import { previousPage as previousPageAction } from '../../../../actions/navigationBar';
import StartConsultNowButtonContainer from './joinConsultNowButton';
import { NetworkTypes } from '../../../../constants/networkTypes.js';
import { Media } from '../../../../mediaSetting';

let htmlToReactParser = new HtmlToReact.Parser(React);

export default function RightPanelOrTopPanel(props) {
  const dispatch = useDispatch();
  const [updatingMicSettings, setUpdatingMicSettings] = useState(false);
  const [updatingCameraSettings, setUpdatingCameraSettings] = useState(false);

  const updateProviderSettings = (type, value) => {
    if (updatingMicSettings || props.fetchingWaitingArea) return;
    if (type == 'microphone') {
      setUpdatingMicSettings(true);
    } else if (type == 'video') {
      setUpdatingCameraSettings(true);
    }

    let cb = () => {
      if (type == 'microphone') {
        setUpdatingMicSettings(false);
      } else if (type == 'video') {
        setUpdatingCameraSettings(false);
      }
    };
    if (type == 'microphone') {
      dispatch(updateMicrophoneSettingsForProvider(props.waitingArea.id, value, cb));
    } else if (type == 'video') {
      dispatch(updateVideoSettingsForProvider(props.waitingArea.id, value, cb));
    }
  };

  const isAbleToJoinCall = (permissions) => {
    if (permissions == null || permissions.length == 0) {
      return false;
    } else {
      return permissions.includes('ANSWER_CALL');
    }
  };

  const renderIconMarkup = (micOrCam, providerCallConfigProps) => {
    if (micOrCam === 'microphone') {
      return (
        <div
          className="toggle-box mic-toggle"
          onClick={() => updateProviderSettings('microphone', !providerCallConfigProps)}
        >
          <div className="toggle-text text-size-ms mic-toggle-text">
            {updatingMicSettings ? (
              <Loader active inverted inline size="mini" style={{ top: '-2px' }} />
            ) : (
              getStatus(providerCallConfigProps)
            )}
          </div>
          <Checkbox toggle checked={providerCallConfigProps} tabIndex="1" />
        </div>
      );
    } else {
      return (
        <div
          className="toggle-box  camera-toggle"
          onClick={() => updateProviderSettings('video', !providerCallConfigProps)}
        >
          <div className="toggle-text text-size-ms camera-toggle-text">
            {updatingCameraSettings ? (
              <Loader active inverted inline size="mini" style={{ top: '-2px' }} />
            ) : (
              getStatus(providerCallConfigProps)
            )}
          </div>
          <Checkbox toggle checked={providerCallConfigProps} tabIndex="1" />
        </div>
      );
    }
  };

  const getStatus = (statusOfCameraOrVideo) => {
    if (statusOfCameraOrVideo) return 'ON';
    else return 'OFF';
  };

  const renderTextMarkup = (micOrCam, renderText, onMobile) => {
    return (
      <div
        className={
          'ui basic label no-bold borderless pdtsss pdbxxs' +
          (onMobile === true && micOrCam === 'video' ? ' no-padding-right' : '')
        }
        data-show="true"
      >
        {micOrCam === 'microphone'
          ? htmlToReactParser.parse('<span id="mic-text">' + renderText + '</span>')
          : htmlToReactParser.parse('<span id="camera-text">' + renderText + '</span>')}
      </div>
    );
  };

  let micIconMarkup = renderIconMarkup('microphone', props.waitingArea.providerCallConfig.isMicrophoneOn);
  let micTextMarkupOnGeneral = renderTextMarkup('microphone', APP.LANGUAGE.ViewOneWaitingArea.MicrophoneIs);
  let micTextMarkupOnMobile = renderTextMarkup(
    'microphone',
    APP.LANGUAGE.ViewOneWaitingArea.MicrophoneIsOnMobile,
    true
  );

  let cameraIconMarkup = renderIconMarkup('video', props.waitingArea.providerCallConfig.isCameraOn);
  let cameraTextMarkupOnGeneral = renderTextMarkup('video', APP.LANGUAGE.ViewOneWaitingArea.CameraIs);
  let cameraTextMarkupOnMobile = renderTextMarkup('video', APP.LANGUAGE.ViewOneWaitingArea.CameraIsOnMobile, true);

  let camMicOption = '';
  if (props.waitingArea.permissions != null && props.waitingArea.permissions.length > 0) {
    if (isAbleToJoinCall(props.waitingArea.permissions)) {
      camMicOption = (
        <div>
          <Container fluid as={Media} greaterThanOrEqual="computer">
            <div id="device-enable-check-session">
              <div className="ui labeled button display-flex center-flex mrbs mrts space-between">
                {micTextMarkupOnGeneral}
                {micIconMarkup}
              </div>
              <div className="ui labeled button display-flex center-flex mrbs mrts space-between">
                {cameraTextMarkupOnGeneral}
                {cameraIconMarkup}
              </div>
            </div>
          </Container>
          <Container fluid as={Media} between={['tablet', 'computer']}>
            <div id="device-enable-check-session" className="mrbm">
              <div className="ui labeled button mrrxl inline-flex center-flex mrbs mrtm space-between">
                {micTextMarkupOnGeneral}
                {micIconMarkup}
              </div>
              <div className="ui labeled button inline-flex center-flex space-between">
                {cameraTextMarkupOnGeneral}
                {cameraIconMarkup}
              </div>
            </div>
          </Container>
          <Container fluid as={Media} at="mobile">
            <div id="device-enable-check-session" className="mrbm">
              <div className="ui labeled button inline-flex center-flex mrbs space-between" style={{ width: '100%' }}>
                {micTextMarkupOnMobile}
                {micIconMarkup}
              </div>
              <div className="ui labeled button inline-flex center-flex space-between" style={{ width: '100%' }}>
                {cameraTextMarkupOnMobile}
                {cameraIconMarkup}
              </div>
            </div>
          </Container>
        </div>
      );
    } else {
      camMicOption = (
        <div className="ui labeled button mrrm non-clickable" tabIndex="0">
          <div className="icon-block">
            <div className="non-clickable no-call-warning color-button-warning">
              <i className="exclamation icon" />
            </div>
          </div>
          <div className="ui basic label no-bold borderless mrrnull mrlnull  pdrnull" data-show={true}>
            <span className="left-text hide-on-small-ress">
              {APP.LANGUAGE.ViewOneWaitingArea.AlertsOnCannotJoinCall}
            </span>
            <span className="left-text show-on-small-ress">
              {APP.LANGUAGE.ViewOneWaitingArea.AlertsOnCannotJoinCallMobile}
            </span>
          </div>
        </div>
      );
    }
  }

  return (
    <div style={{ height: '100%' }}>
      <Container fluid as={Media} greaterThanOrEqual="computer" style={{ height: '100%' }}>
        <div className="right-top-waiting-area-view-one ui form mrtnull">
          {props.waitingArea && props.waitingArea.isCustomBrandingEnabled && props.waitingArea.logoUrls ? (
            <div className="branding-logo-container max-width logo-on-right-hand">
              <CustomBrandingLogo
                wrapperClass="fr"
                waitingArea={props.waitingArea}
                isDisplayingDefaultLogo={!(props.waitingArea.logoUrls.logoUrl || props.waitingArea.logoUrls.orgLogoUrl)}
                dispatch={dispatch}
              />
            </div>
          ) : props.waitingArea && props.waitingArea.isCustomBrandingEnabled == false ? (
            <div className="pdtxl pdbm pdrm logo-on-right-hand">
              <img className="ui image pdtxs umbrella-logo umbrella-logo-large" src={APP.IMAGES.UmbrellaLogo.default} />
              <img className="ui image  umbrella-logo umbrella-logo-small" src={APP.IMAGES.SmallUmbrellaLogo.default} />
            </div>
          ) : (
            <div className="pdtxl pdbm pdrm logo-on-right-hand" />
          )}
          {props.showAdvancedMenu ? (
            ''
          ) : props.isConsultNowEnabled &&
            props.activeTabItem === APP.LANGUAGE.ViewOneWaitingArea.ConsultNow.toUpperCase() ? (
            <div>
              <div className="color-white-bg pdtm pdbm pdll pdrm">
                <div className="mrbs bold">
                  <div>{APP.LANGUAGE.ViewOneWaitingArea.ConsultNow}</div>
                </div>
                <div className="mrbs">
                  <span>{APP.LANGUAGE.ViewOneWaitingArea.ConsultNowInfoPart1}</span>
                  <span>{APP.LANGUAGE.ViewOneWaitingArea.ConsultNowInfoPart2}</span>
                </div>
                <StartConsultNowButtonContainer waitingArea={props.waitingArea} dispatch={dispatch} />
              </div>
              {!!props.waitingArea.operatingHours && !!props.waitingArea.supportSetting ? (
                <div className="pdbm pdrm pdlm">{props.bottomSession}</div>
              ) : (
                ''
              )}
            </div>
          ) : (
            <div>
              {props.waitingArea.networkTypeId === NetworkTypes.GroupConsultation ? (
                ''
              ) : (
                <div className="color-white-bg pdtm pdbm pdll pdrm">
                  <MobileAlerts fetchingWaitingArea={props.fetchingWaitingArea} />
                  {props.fetchingWaitingArea ? '' : camMicOption}
                </div>
              )}
              {!!props.waitingArea.operatingHours && !!props.waitingArea.supportSetting ? (
                <div className="pdbm pdrm pdlm">{props.bottomSession}</div>
              ) : (
                ''
              )}
            </div>
          )}
          {props.waitingArea &&
            props.waitingArea.isCustomBrandingEnabled != null &&
            props.activeTabItem !== APP.LANGUAGE.ViewOneWaitingArea.ConsultNow.toUpperCase() && (
              <AdvancedSettings
                waitingArea={props.waitingArea}
                isAdmin={props.isAdmin}
                verticallyCenter={props.waitingArea && props.waitingArea.isCustomBrandingEnabled}
              />
            )}
        </div>
      </Container>
      <Container fluid as={Media} lessThan="computer">
        {props.isConsultNowEnabled &&
        props.activeTabItem === APP.LANGUAGE.ViewOneWaitingArea.ConsultNow.toUpperCase() ? (
          <div className="right-top-waiting-area-view-one ui form mrtnull">
            <div className="color-white-bg pdbm pdlm pdrm">
              <div className="mrts pdts mrbm">
                <Link
                  className={
                    'back-to-wa-link left-text ' +
                    (props.previousPage !== window.APP.LANGUAGE.ViewAllOrgUnit.Title && props.hasWaitingAreaAccess
                      ? 'color-waiting-area-text'
                      : 'back-to-org-link')
                  }
                  to={
                    props.previousPage !== window.APP.LANGUAGE.ViewAllOrgUnit.Title && props.hasWaitingAreaAccess
                      ? `/waiting-area/view-all`
                      : `/organisational-unit/view-all`
                  }
                  onClick={() => {
                    dispatch(previousPageAction(window.APP.LANGUAGE.ViewOneWaitingArea.Title));
                  }}
                >
                  <i className="chevron circle left icon" />
                  <span>
                    {props.previousPage !== window.APP.LANGUAGE.ViewAllOrgUnit.Title && props.hasWaitingAreaAccess
                      ? APP.LANGUAGE.ViewOneWaitingArea.BackToWaitingAreasLinkText
                      : APP.LANGUAGE.OrganisationalUnitManageUsers.BackToOrganisationalUnitLinkText}
                  </span>
                </Link>
              </div>
            </div>
            <div className="pdlm pdrm mrbm">
              <div className="mrbs bold">
                <div>{APP.LANGUAGE.ViewOneWaitingArea.ConsultNow}</div>
              </div>
              <div className="mrbs">
                <div>{APP.LANGUAGE.ViewOneWaitingArea.ConsultNowInfoPart1}</div>
                <div>{APP.LANGUAGE.ViewOneWaitingArea.ConsultNowInfoPart2}</div>
              </div>
              <StartConsultNowButtonContainer waitingArea={props.waitingArea} dispatch={dispatch} />
            </div>
          </div>
        ) : (
          <div className="right-top-waiting-area-view-one ui form mrtnull">
            <div className="color-white-bg pdbm pdlm pdrm">
              {props.waitingArea.networkTypeId === NetworkTypes.GroupConsultation ? (
                <div className="ui actions header-action-button max-width show-on-small-ress">
                  <button
                    type="button"
                    className={props.actionButtonClass}
                    style={props.actionButtonStyle}
                    onClick={props.actionButtonOnClick}
                  >
                    {props.actionButtonText}
                  </button>
                </div>
              ) : (
                <React.Fragment>
                  <MobileAlerts fetchingWaitingArea={props.fetchingWaitingArea} />
                  {props.fetchingWaitingArea ? '' : camMicOption}
                  <div className="mrts pdts mrbm">
                    <Link
                      className={
                        'back-to-wa-link left-text ' +
                        (props.previousPage !== window.APP.LANGUAGE.ViewAllOrgUnit.Title && props.hasWaitingAreaAccess
                          ? 'color-waiting-area-text'
                          : 'back-to-org-link')
                      }
                      to={
                        props.previousPage !== window.APP.LANGUAGE.ViewAllOrgUnit.Title && props.hasWaitingAreaAccess
                          ? `/waiting-area/view-all`
                          : `/organisational-unit/view-all`
                      }
                      onClick={() => {
                        dispatch(previousPageAction(window.APP.LANGUAGE.ViewOneWaitingArea.Title));
                      }}
                    >
                      <i className="chevron circle left icon" />
                      <span>
                        {props.previousPage !== window.APP.LANGUAGE.ViewAllOrgUnit.Title && props.hasWaitingAreaAccess
                          ? APP.LANGUAGE.ViewOneWaitingArea.BackToWaitingAreasLinkText
                          : APP.LANGUAGE.OrganisationalUnitManageUsers.BackToOrganisationalUnitLinkText}
                      </span>
                    </Link>
                  </div>
                </React.Fragment>
              )}
            </div>
            <AdvancedSettings waitingArea={props.waitingArea} isAdmin={props.isAdmin} />
          </div>
        )}
      </Container>
    </div>
  );
}
